// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3IVWp","content":"LayoutSettings_content__tn9-J"};